module.exports = __webpack_public_path__ + "img/mt_shop_arrow.e7a32b45.png";